import { Dimensions, StyleSheet } from 'react-native'
import theme from '../../../../theme'

const width = Dimensions.get('window').width

const styles = StyleSheet.create({
    modalContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        alignContent: 'flex-start',
        justifyContent: 'center',
        marginTop: 0,
    },
    modalTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 4,
        color: theme.colors.textPrimary,
    },
    modalSubtitle: {
        fontSize: 16,
        fontWeight: 'normal',
        marginBottom: 15,
        marginHorizontal: 20,
        textAlign: 'center',
        color: theme.colors.textSecondary,
    },
    inputBlock: {
        flexDirection: 'row',
        width: '100%',
        height: 40,
        borderWidth: 1,
        borderRadius: 10,
        borderColor: theme.colors.lightGray,
        backgroundColor: 'white',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 20,
        marginTop: 0,
    },
    container: {
        flex: 1,
        padding: 15,
    },
    scrollView: {
        flex: 1,
        justifyContent: 'space-between',
    },
    logoutBlock: {
        marginTop: 25,
        alignItems: 'center',
    },
    logoutText: {
        fontSize: 16,
        color: theme.colors.error,
        fontWeight: 'bold',
    },
    buttonContainer: {
        flexDirection: 'column',
        paddingHorizontal: 12,
        width: '100%',
    },
    mainButton: {
        marginTop: 10,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
    },
    mainButtonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    borderButton: {
        marginTop: 10,
        backgroundColor: 'white',
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
    },
    borderButtonText: {
        fontSize: 16,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    borderRedButton: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 10,
        backgroundColor: 'white',
        borderWidth: 2,
        borderColor: theme.colors.error,
        padding: 10,
        borderRadius: 10,
    },
    version: {
        fontSize: 13,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingBottom: 12,
    },
    iconButton: {
        marginLeft: 5,
    },
    borderRedButtonText: {
        color: theme.colors.error,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    containerModal: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    spacer1: {
        height: 15,
    },
    spacer: {
        height: 45,
    },
    inputLocked: {
        height: 40,
        marginTop: 5,
        marginBottom: 15,
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.disabled,
        backgroundColor: theme.colors.disabled,
        color: theme.colors.textSecondary,
        padding: 10,
    },
    inputCode: {
        borderWidth: 1,
        borderRadius: 8,
        borderColor: theme.colors.lightGray,
        marginHorizontal: 4,
        width: width / 8,
        height: 60,
    },
    inputCodeText: {
        fontSize: 26,
        fontWeight: '600',
        textAlign: 'center',
        color: theme.colors.textPrimary,
    },
    tagInput: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
    },
    editIcon: {
        justifyContent: 'Top',
        marginTop: 0,
    },
    modalOverlay: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fondo semi-transparente
    },
    input_verification: {
        width: '100%',
        height: 40,
        borderColor: theme.colors.lightGray,
        borderWidth: 0.5,
        borderRadius: 5,
        paddingHorizontal: 12,
        marginBottom: 12,
    },
    image: {
        width: 120,
        height: 120,
    },
})

export default styles
